import axios from 'axios';
import * as endpoints from './const';

class DemoApi {
  static requestDemo(fetchParams) {
    return axios
      .post(endpoints.REQUEST_DEMO, fetchParams)
      .then(response => response.data)
      .then(data => data);
  }
}

export default DemoApi;



// WEBPACK FOOTER //
// ./src/api/DemoApi.js